<template>
    <div class="container">
        <div v-if="errors" v-for="error in errors">
            <div class="alert alert-danger" role="alert">{{ error}}</div>
        </div>

        <div class="loginPage">
            <div class="login">
                <form v-on:submit.prevent="reset()">
                    <h1 class="h3 mb-3 font-weight-normal">Запрос на изменение пароля</h1>
                    <label for="inputEmail" class="sr-only">Email address</label>
                    <input type="email" id="inputEmail" class="form-control" placeholder="Email address" v-model="email"
                           required autofocus>

                    <button class="btn btn-lg btn-primary btn-block btn-yellow" type="submit">Отправить</button>
                </form>
            </div>
        </div>
    </div>
</template>

<script>
    const swal = require('sweetalert2');
    export default {
        data() {
            return {
                email: '',
                errors: []
            }
        },
        methods: {
            checkForm: function () {
                this.errors = [];
                if (!this.email) this.errors.push("Email обязателен.");
            },

            reset() {
                this.checkForm()
                let formData = new FormData();
                formData.append('email', this.email);
                if (this.errors.length === 0) {
                    this.axios
                        .post(this.axios.defaults.baseURL + 'password/email', formData)
                        .then(response => {
                            if (response){
                                swal.fire({
                                    icon: 'success',
                                    title: 'Проверьте почту',
                                    showConfirmButton: true,
                                });
                            }
                        })
                        .catch(error => {
                            console.log(error);
                        })
                }
            }
        }
    }
</script>

<style scoped>

    .btn-yellow{
        background-color: #e8d800;
        color: #000;
        box-shadow: none!important;
        border: 0;
    }

    .btn-yellow:hover{
         background-color: #000;
         color: #fff;
     }

    .flx{
        margin: 15px 0;
    }

    .reg{
        color: #000;
        font-size: 16px;
    }

    .form-signin .form-control {
        position: relative;
        box-sizing: border-box;
        height: auto;
        padding: 10px;
        font-size: 16px;
    }

    .form-signin .form-control:focus {
        z-index: 2;
    }

    .form-signin input[type="email"] {
        margin-bottom: -1px;
        border-bottom-right-radius: 0;
        border-bottom-left-radius: 0;
    }

    .form-signin input[type="password"] {
        margin-bottom: 10px;
        border-top-left-radius: 0;
        border-top-right-radius: 0;
    }

    input {
        margin: 15px 0;
    }

    .loginPage {
        display: flex;
        justify-content: center;
        align-items: center;
        height: 100vh;
    }

    .login {
        width: 350px;
    }
</style>



// WEBPACK FOOTER //
// src/views/app/pages/auth/reset.vue